module.exports = __webpack_public_path__ + "img/prerogative_4@2x.19ffeea9.png";